import styles from '@/styles/About.module.css'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const PanPizza = dynamic(() => import('@/components/PanPizza'))

const Page = () => {
  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Pan Pizzor Meny</title>
        <meta
          name='description'
          content='Upplev en härlig smakexplosion med vår panpizza! Vårt krispiga pizzabotten toppas med en generös mängd av dina favorittillbehör, allt bakat till perfektion i vår vedeldade pizzaugn. Välkommen in och låt dig väl smaka!'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      <PanPizza
        title='Pan Pizzor'
        head=' Alla pizzor innehåller tomatsås och ost'
      />
    </main>
  )
}

export default Page
